/**
 * This component is used to show the navigation on the website.
 * The navigation is passed in as json-file via ajax-call.
 * With this provided data, there will be menuItems generated,
 * which gets shown in the render-function.
 *
 * This React component will be handled in the navigationInit.js,
 * which renders it to the _header.html.erb.
 *
 */

import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';

import { MenuItem } from './MenuItem';
import WidgetRenderer from './widgets/widgetRenderer';
import { NavigationSearch } from './search';

class Navigation extends React.Component {
  constructor() {
    super();
    this.state = {
      menuItems: [],
      activePath: [],
      mobileNavigationWidgets: []
    };

    // a variable to save the screen width for multiple iterations
    this.screenWidth = document.body.clientWidth;
  }

  componentDidMount() {
    this.ajaxActive();
    this.mobileNavigationWidgets();
  }

  showTooltip(isSmallWidth) {
    if (!isSmallWidth) {
      const $tooltipWrapper = $('.goldencobra_widget .tooltip-wrapper');

      $tooltipWrapper.each((_index, element) => {
        const $element = $(element);
        const elementTrigger = $element.data('trigger');

        $(elementTrigger)
          .add(element)
          .unbind('mouseover')
          .unbind('mouseout')
          .mouseover(() => {
            $element.stop(true, false).fadeIn(200);
          })
          .mouseout(() => {
            $element.stop(true, false).fadeOut(200);
          });
      });
    }
  }

  addDropdownIconToSmallScreenNavigation() {
    $('.menu > ul > li > .second-layer-wrapper > ul > li:not(.has-menu-dropdown):has(> ul)')
      .addClass('has-menu-dropdown')
      .prepend('<i class="fa qb-plus hidden-desktop"></i>');

    $('.menu > ul > li:not(.has-menu-dropdown) > .second-layer-wrapper:has(> ul)')
      .parent()
      .addClass('has-menu-dropdown')
      .prepend('<i class="fa qb-plus hidden-desktop"></i>');
  }

  /**
   * When on small screen, the child-items of the menu shall initially not be displayed,
   * just onClick of the parent (see expandSmallScreenNavigation()).
   *
   * @param {boolean} { isSmallWidth } true if screen is < 800, provided by initNavigationBehavior()
   */
  closeAllSmallScreenSubNavigations(isSmallWidth) {
    if (isSmallWidth) {
      // hide all open sub layers
      $('.has-menu-dropdown > ul, .has-menu-dropdown > div').slideUp(200);

      // rotate all dropdown icons
      $('.has-menu-dropdown > i').removeClass('qb-minus').addClass('qb-plus');
    }
  }

  /**
   * On click, the child-items of the menu will be displayed.
   * The dropdown-icon receives a css-class, which rotates the icon.
   *
   * @param {boolean} { isSmallWidth } true if screen is < 800, provided by initNavigationBehavior()
   */
  expandSmallScreenNavigation(isSmallWidth) {
    if (isSmallWidth) {
      // click on top-level navigation closes every other level navigation
      $('.menu > ul > li > a')
        .unbind('click')
        .click((e) => {
          e.preventDefault();

          this.closeAllSmallScreenSubNavigations(isSmallWidth);
        });

      // click on menu item parent (second layer of navigation)
      // opens the sub navigation
      $('.has-menu-dropdown > a, .has-menu-dropdown > i')
        .unbind('click')
        .click((e) => {
          const $this = $(e.currentTarget);
          const $parent = $this.parent();

          e.preventDefault();

          // hide other open sibling navigations
          $parent.siblings('.has-menu-dropdown').children('ul, div').slideUp(200);

          $parent.children('ul, div').slideToggle(200);

          $parent.siblings().children('i').removeClass('qb-minus').addClass('qb-plus');

          $parent.children('i').toggleClass('qb-plus qb-minus');
        });
    } else {
      // click on top-level navigation
      $('.menu > ul > li > a')
        .unbind('click')
        .click((e) => {
          const $this = $(e.currentTarget);

          // prevent default link behavior going to referenced href
          e.preventDefault();

          // show every menu item of the parent of this currently clicked menu item on desktop
          $this
            .parent()
            .children('.second-layer-wrapper')
            .children('ul')
            .children('li')
            .children('ul')
            .show();

          // after opening every menu item we need to toggle the icon to be in opened state
          // to have no conflicts with responsive behavior
          $('.has-menu-dropdown > i').removeClass('qb-plus').addClass('qb-minus');
        });

      // click on menu item parent (second layer of navigation)
      // should do nothing on desktop
      // prevent default link behavior going to referenced href
      $('.menu > ul > li > .second-layer-wrapper > ul > li > a')
        .unbind('click')
        .click((e) => e.preventDefault());

      // always show every menu item of each parent on desktop
      $('.menu > ul > li > .second-layer-wrapper > ul > li > ul').show();

      // after opening every menu item we need to toggle the icon to be in opened state
      // to have no conflicts with responsive behavior
      $('.has-menu-dropdown > i').removeClass('qb-plus').addClass('qb-minus');
    }
  }

  /**
   * This function receives the variable `isSmallWidth` and calls functions for different screen
   * behaviors.
   */
  initNavigationBehavior(isSmallWidth) {
    this.closeAllSmallScreenSubNavigations(isSmallWidth);
    this.expandSmallScreenNavigation(isSmallWidth);
    this.showTooltip(isSmallWidth);
    this.initSearch(isSmallWidth);
  }

  initSearch(isSmallWidth) {
    const searchContainer = document.getElementById(
      isSmallWidth ? 'mobile-navigation-search-container' : 'navigation-search-container'
    )

    if (!searchContainer) {
      return;
    }

    if (isSmallWidth) {
      const $navigation = $('.navigation');
      const $mobileNavigationButton = $('.mobile-navigation .navigation-button');
      const $mobileNavigationSearch = $('#mobile-navigation-search');
      const $mobileNavigationSearchContainer = $('#mobile-navigation-search-container');

      $mobileNavigationSearch.unbind('click').click((e) => {
        // prevent default link behavior going to referenced href
        e.preventDefault();

        // toggle search container
        const isSearchClosed = $mobileNavigationSearch.attr('aria-expanded') == 'false';

        if (isSearchClosed) {
          // hide navigation if open
          const isNavigationOpen = $mobileNavigationButton.attr('aria-expanded') == 'true';

          if (isNavigationOpen) {
            $mobileNavigationButton.attr('aria-expanded', 'false');
            $navigation.stop(true, false).fadeOut(200);
          }

          // show search
          $mobileNavigationSearch.attr('aria-expanded', 'true');
          $mobileNavigationSearchContainer.stop().fadeIn(200);

          // focus search field
          $('#mobile-navigation-search-container input[type="search"]').focus();
        } else {
          $mobileNavigationSearch.attr('aria-expanded', 'false');
          $mobileNavigationSearchContainer.stop().fadeOut(200);
        }
      });
    } else {
      $('#navigation-search').unbind('click').click((e) => {
        // prevent default link behavior going to referenced href
        e.preventDefault();

        // focus search field
        $('#navigation-search-container input[type="search"]').focus();
      });
    }

    // render search field with react
    ReactDOM.render(<NavigationSearch />, searchContainer);
  }

  /**
   * On desktop the navigation should appear on mouseover and disappear on mouseout (QB-990).
   * For small screens a click triggers the navigation and a second click closes it.
   */
  toggleMegaNavigation() {
    const isSmallWidth = document.body.clientWidth < 800;
    const $navigation = $('.navigation');
    const $mobileNavigation = $('.mobile-navigation');
    const $mobileNavigationButton = $('.mobile-navigation .navigation-button');
    const $mobileNavigationSearch = $('#mobile-navigation-search');
    const $mobileNavigationSearchContainer = $('#mobile-navigation-search-container');

    if (!isSmallWidth) {
      $navigation.show();
      $mobileNavigationSearch.attr('aria-expanded', 'false');
      $mobileNavigationSearchContainer.hide();

      $('.menu > ul > li > a')
        .unbind('click')
        .unbind('mouseover')
        .mouseover((e) => {
          const $this = $(e.currentTarget);
          const $secondLayer = $this.siblings('.second-layer-wrapper');

          // open the second layer of the hovered menu item
          $secondLayer.stop(true, false).fadeIn(200);

          // close all menu items that were not hovered
          $this.parent().siblings('li').children('.second-layer-wrapper').stop(true, false).hide();

          $secondLayer.unbind('mouseover').mouseover(() => {
            // keep the hovered menu wrapper open
            $secondLayer.stop(true, false).fadeIn(200);
          });
        });

      $('.menu > ul > li > a, .menu > ul > li > .second-layer-wrapper')
        .unbind('mouseout')
        .mouseout(() => {
          // close all second layer menu items
          $('.menu > ul > li > .second-layer-wrapper').stop(true, false).fadeOut(200);
        });
    } else {
      $('.menu > ul > li > a, .menu > ul > li > .second-layer-wrapper').unbind('mouseout');
      $navigation.hide();
      $mobileNavigationButton.attr('aria-expanded', 'false');
      $mobileNavigation.removeClass('background-white');

      $('.menu > ul > li > a')
        .unbind('mouseover')
        .unbind('click')
        .click((e) => {
          const $this = $(e.currentTarget);
          const $secondLayer = $this.siblings('.second-layer-wrapper');

          // prevent default link behavior going to referenced href
          e.preventDefault();

          // callback function to close all menu items that were not clicked
          const closeAllMenuItems = () => {
            $this
              .parent()
              .siblings('li')
              .children('.second-layer-wrapper')
              .stop(true, false)
              .slideUp(200);
          };

          $secondLayer.stop(true, false).slideToggle(200);

          closeAllMenuItems();
        });

      /**
       * if the mobile navigation is open, close it. if it is closed, open it.
       * also toggle .no-scroll on the body.
       * that class prevents scrolling of the page, but only in the navigation container.
       */
      const toggleMobileNavigation = () => {
        const isNavigationClosed = $mobileNavigationButton.attr('aria-expanded') == 'false';

        if (isNavigationClosed) {
          // hide search if open
          const isSearchOpen = $mobileNavigationSearch.attr('aria-expanded') == 'true';

          if (isSearchOpen) {
            $mobileNavigationSearch.attr('aria-expanded', 'false');
            $mobileNavigationSearchContainer.stop().fadeOut(200);
          }

          $mobileNavigationButton.attr('aria-expanded', 'true');
          $navigation.stop(true, false).fadeIn(200);
        } else {
          $mobileNavigationButton.attr('aria-expanded', 'false');
          $navigation.stop(true, false).fadeOut(200);
        }

        $mobileNavigation.toggleClass('background-white');
      };

      $mobileNavigationButton.unbind('click').click(() => {
        toggleMobileNavigation();
      });

      this.addDropdownIconToSmallScreenNavigation();
    }

    this.initNavigationBehavior(isSmallWidth);

    const that = this;
    $(window)
      .unbind('resize')
      .resize(() => {
        const newScreenWidth = document.body.clientWidth;

        if (
          (that.screenWidth < 800 && newScreenWidth >= 800) ||
          (that.screenWidth >= 800 && newScreenWidth < 800)
        ) {
          that.toggleMegaNavigation();
        }

        that.screenWidth = document.body.clientWidth;
      });
  }

  ajaxActive() {
    const menuId = 1,
          pathname = window.location.pathname;

    $.ajax({
      url: `/api/v2/navigation_menus/active.json?id=${menuId}&url=${pathname}`,
      method: 'GET',
      success: (data) => {
        if (data !== undefined && data !== null) {
          this.setState({ activePath: data }, () => {
            this.ajaxNavigation(menuId);
          });
        }
      },
      error: (xhr, status, err) => console.error(menuId, status, err.toString())
    });
  }

  /**
   * This function is called in componentDidMount() and processes the json-file.
   * For every main menu item there is a check for widgets. This works asynchronously, so
   * we have a struggle when to call createMenuItems() and toggleMegaNavigation().
   * For every widget check there is a callback. This callback sets the widgets for the iterated
   * menu item.
   * The implementation now works (after hours) with calling the menu creation only for the last
   * element with widget ids. Therefore we have an filtered array on menu items with widget ids.
   * At the end we have a callback to create menu items which is called in the callback of
   * getting widgets after the last main menu item with widget ids is processed.
   */
  ajaxNavigation(menuId) {
    $.ajax({
      url: `/api/v2/navigation_menus.json?id=${menuId}&depth=3&methods=mobile_title,widget_ids`,
      method: 'GET',
      success: (data) => {
        if (data !== undefined && data !== null) {
          const createMenuCallback = (widgetsForMenuItem) => {
                  this.setState(
                    {
                      menuItems: createMenuItems(data, this.state.activePath, widgetsForMenuItem)
                    },
                    () => {
                      this.toggleMegaNavigation();
                    }
                  );
                },
                widgetsForMenuItem = {},
                menuItemsWithWidget = data.filter(
                  (item) => item.widget_ids.filter((id) => id !== '').length // reject blank entries
                );

          $.each(data, (index, item) => {
            WidgetRenderer.widgetsForObject(
              item,
              (widgets) => {
                widgetsForMenuItem[item.id] = widgets;
                if (menuItemsWithWidget[menuItemsWithWidget.length - 1].id === item.id) {
                  createMenuCallback(widgetsForMenuItem);
                }
              },
              'widget_ids'
            );
          });
        }
      },
      error: (xhr, status, err) => console.error(menuId, status, err.toString())
    });
  }

  mobileNavigationWidgets() {
    WidgetRenderer.widgetsForObject(
      { positions: ['menu'] },
      (widgets) => this.setState({ mobileNavigationWidgets: widgets }),
      'positions',
      true
    );
  }

  /**
   * the complete Array of menu-items gets rendered into a list,
   * which itself doesn't display anything on the top level.
   * If there is no valid json-file given, it will render an empty list.
   */
  render() {
    return (
      <div className="menu-container">
        <div className="menu">
          <ul>{this.state.menuItems}</ul>
          <div className="mobile-widgets hidden-desktop">
            {this.state.mobileNavigationWidgets.map((widget) => (
              <div
                key={`widget-${widget.id}`}
                dangerouslySetInnerHTML={{ __html: widget.content }}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default Navigation;

/**
 * General function to fill up the array of menu-data.
 * Each array-item will be pushed to the MenuItems-function, where it gets displayed.
 * The returned array of all data will be passed to the render-function.
 *
 * @param  {json} {menuData} the data provided by the ajax success
 *
 * @return {array} {menuItems} complete react components of navigation
 */
export function createMenuItems(menuData, activePath, widgets) {
  const menuItems = [];

  $.each(menuData, (index, value) => {
    const menuWidgets = widgets && widgets[value.id] ? widgets[value.id] : [];

    menuItems.push(
      <MenuItem
        menuData={value}
        activePath={activePath}
        widgets={menuWidgets}
        key={`${value.id}_${index}`}
      />
    );
  });

  return menuItems;
}



// WEBPACK FOOTER //
// ./components/navigation.js